export default __webpack_public_path__ + "static/media/receptionist.d022bfff.jpg";